import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from './api';

import { TarifChangeNotificationStateData } from './types';

const initialState: TarifChangeNotificationStateData = {
	data: { data: { username: '', message: null }, error: null },
	loading: false,
	error: '',
};

export const fetchGetTarifNotification = createAsyncThunk('api/fetchGetTarifNotification', (action: string) =>
	api.fetchGetTarifNotification(action)
);
export const fetchAddTarifNotification = createAsyncThunk(
	'api/fetchAddTarifNotification',
	({ session_id, message }: { session_id: string; message: string }) =>
		api.fetchAddTarifNotification({ session_id, message }),
);
export const fetchDeleteTarifNotification = createAsyncThunk('api/fetchDeleteTarifNotification', (action: string) =>
	api.fetchDeleteTarifNotification(action)
);

const changeTarifNotificationSlice = createSlice({
	name: 'tarifNotification',
	initialState,
	reducers: {},
	extraReducers(builder) {
		builder
			.addCase(fetchGetTarifNotification.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchGetTarifNotification.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload || {};
				state.error = '';
			})
			.addCase(fetchGetTarifNotification.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message || 'Ошибка загрузки данных';
			})

			.addCase(fetchAddTarifNotification.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchAddTarifNotification.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload || {};
				state.error = '';
			})
			.addCase(fetchAddTarifNotification.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message || 'Ошибка загрузки данных';
			})

			.addCase(fetchDeleteTarifNotification.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchDeleteTarifNotification.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload || {};
				state.error = '';
			})
			.addCase(fetchDeleteTarifNotification.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message || 'Ошибка загрузки данных';
			});
	},
});

export default changeTarifNotificationSlice.reducer;
